import { render } from "./tab-question.vue?vue&type=template&id=093421c5&scoped=true"
import script from "./tab-question.vue?vue&type=script&lang=js"
export * from "./tab-question.vue?vue&type=script&lang=js"

import "./tab-question.vue?vue&type=style&index=0&id=093421c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093421c5"]])

export default __exports__